const collections = {
  templates: 'templates',
  organizations: 'organizations',
  configurations: 'configurations',
  subsidiaries: 'subsidiaries',
  chats: 'chats',
  gestiones: 'gestiones',
  clients: 'clients',
  users: 'users',
  messages: 'messages',
  patients: 'patients',
  bills: 'bills',
};

export default collections;
